/** Batch size fetched for client-side filtering in model view. */
export const PORTFOLIO_SEARCH_FETCH_SIZE = 500;

export function getServerPagination({
  page,
  pageSize,
  isClientFilter,
}: {
  page: number;
  pageSize: number;
  isClientFilter: boolean;
}): { perPage: number; offSet: number } {
  if (isClientFilter) {
    return { perPage: PORTFOLIO_SEARCH_FETCH_SIZE, offSet: 0 };
  }
  return { perPage: pageSize, offSet: (page - 1) * pageSize };
}

export function getPaginationRequestKey({
  page,
  pageSize,
  isClientFilter,
  serverSearchText = '',
}: {
  page: number;
  pageSize: number;
  isClientFilter: boolean;
  serverSearchText?: string;
}): string {
  const { offSet, perPage } = getServerPagination({
    page,
    pageSize,
    isClientFilter,
  });
  const searchSuffix =
    !isClientFilter && serverSearchText.trim()
      ? `:q:${serverSearchText.trim()}`
      : '';
  return `${offSet}:${perPage}:${isClientFilter ? 'client-batch' : 'server'}${searchSuffix}`;
}

export function sliceClientPage<T>(
  items: readonly T[],
  page: number,
  pageSize: number,
): T[] {
  const start = (page - 1) * pageSize;
  return items.slice(start, start + pageSize);
}

export function getPageCount(totalCount: number, pageSize: number): number {
  if (totalCount <= 0 || pageSize <= 0) return 1;
  return Math.ceil(totalCount / pageSize);
}

export function shouldResetPage(page: number, totalPages: number): boolean {
  return totalPages > 0 && page > totalPages;
}

export function shouldShowPortfolioPagination(
  isClientFilter: boolean,
  filteredCount: number,
  totalCount: number,
): boolean {
  return isClientFilter ? filteredCount > 0 : totalCount > 0;
}
